<template>
<ContentGroup>
  <BlockGroup inline>
    <Block
      label="คณะ"
      no-border
    >
      <SelectBox
        label="คณะ"
        prop="facultyId"
        :required="!data.warning['facultyId']"
        :edata="data.newProfile['facultyId']"
        @input="methods.inputHandler"
        :options="facultyOptions"
      />
    </Block>
    <Block
      label="หลักสูตร"
      no-border
    >
      <SelectBox
        label="หลักสูตร"
        prop="curriculumId"
        :required="!data.warning['curriculumId']"
        :edata="data.newProfile['curriculumId']"
        @input="methods.inputHandler"
        :options="curriculumOptions"
      />
    </Block>

  </BlockGroup>

  <BlockGroup inline>
    <Block
      label="อาจารย์พิเศษ"
      no-border
    >
      <vs-checkbox
        class="mb-3"
        prop="isSpecialTeacher"
        v-model="data.newProfile['isSpecialTeacher']"
        @input="methods.inputHandler"
      >
        อาจารย์พิเศษ
      </vs-checkbox>
      <!--<CheckBox
        label="อาจารย์พิเศษ"
        prop="isSpecialTeacher"
        :edata="data.newProfile['isSpecialTeacher']"
        @input="methods.inputHandler"
        :options="[
          {
            title: 'อาจารย์พิเศษ',
            value: 'Y',
          },
        ]"
      />-->
    </Block>
    <Block
      label="ใช้งาน"
      no-border
    >
      <vs-checkbox
        class="mb-3"
        prop="isActive"
        v-model="data.newProfile['isActive']"
        @input="methods.inputHandler"
      >
        ใช้งาน
      </vs-checkbox>
      <!--<CheckBox
        label="ใช้งาน"
        prop="isActive"
        :edata="data.newProfile['isActive']"
        @input="methods.inputHandler"
        :options="[
          {
            title: 'ใช้งาน',
            value: 'Y',
          },
        ]"
      />-->
    </Block>

  </BlockGroup>

</ContentGroup>
</template>

<script>
import ContentGroup from "@/components/common-ui/content-group/index.vue";
import BlockGroup from "@/components/common-ui/block-group/index.vue";
import Block from "@/components/common-ui/block/index.vue";
import SelectBox from "@/components/common-ui/forms/select-box/index.vue";
import data from "../data";

export default {
  components: {
    ContentGroup,
    BlockGroup,
    Block,
    SelectBox
  },
  data() {
    return {
      ...data
    }
  },
  props: {
    methods: Object,
  },
  computed: {
    facultyOptions() {
      return this.$store.state.MasterData.faculties;
    },
    curriculumOptions() {
      if (this.data.newProfile.facultyId) {
        const facultyId = this.data.newProfile.facultyId;
        if (this.$store.state.MasterData.curriculums) {
          const curriculum = this.$store.state.MasterData.curriculums;
          if (Array.isArray(curriculum)) {
            return curriculum.filter(item => {
              return item.faculty.id === facultyId;
            })
          }
        }
      }
      return this.$store.state.MasterData.curriculums;
    }
  },
}
</script>
